<template>
  <div />
</template>

<script>

export default {
  name: 'penlight-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'ASSESSMENT',
        id: 'PENLIGHT',
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
